import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { first, map, Observable } from 'rxjs';

import { ROUTES } from '../definitions/constants/routes.constants';
import { User } from '../definitions/interfaces/user/user';
import { UserConfigsStoreFacade } from '../stores/global-store/user-configs/user-configs-store.facade';

// Dev Note: Requirements from https://jira.bbraun.com/browse/W39TOM-12056
export const appRoutingGuard: CanActivateFn = (snapshot, state): boolean | Observable<UrlTree | boolean> => {
  const userConfigsFacade = inject(UserConfigsStoreFacade);
  const router = inject(Router);

  if (state.url.includes('auth/callback')) return true;

  return userConfigsFacade.user$.pipe(
    first((user): user is User => !!user),
    map(() => {
      const goToPortal = (
        (userConfigsFacade.hasReplenishmentOnlyCustomersSignal() || userConfigsFacade.hasHybridCustomersSignal())
        && userConfigsFacade.hasRepEvolutionOnlyCustomersSignal()
      );
      const goToReplenishment = (
        (userConfigsFacade.hasReplenishmentOnlyCustomersSignal() || userConfigsFacade.hasHybridCustomersSignal())
        && !userConfigsFacade.hasRepEvolutionOnlyCustomersSignal()
      );
      const goToRepEvolution = (
        (!userConfigsFacade.hasReplenishmentOnlyCustomersSignal() && !userConfigsFacade.hasHybridCustomersSignal())
        && userConfigsFacade.hasRepEvolutionOnlyCustomersSignal()
      );

      if (goToPortal || userConfigsFacade.isSuperAdminSignal()) {
        return router.createUrlTree([ ROUTES.APP_PORTAL ]);
      }
      if (goToReplenishment) {
        return router.createUrlTree([ ROUTES.REPLENISHMENT ]);
      }
      if (goToRepEvolution) {
        return router.createUrlTree([ ROUTES.REP_EVOLUTION ]);
      }
      return false;
    })
  );
};
